module.exports = __webpack_public_path__ + "static/media/MITECOLogo.7df5585c.png";